import { Component, OnChanges, Input, EventEmitter, Output, OnInit } from '@angular/core';
import {  JourneyItemDto, LocationServiceDto} from 'src/shared/service-proxies/service-proxies';
import * as moment from 'moment';
import { DateTimeHelper } from 'src/app/helpers/datetime';
import { JobItemModel } from '../models';
import { Router } from '@angular/router';
import { DashboardMode } from 'src/app/dashboard-live/dashboard-live.component';

@Component({
  selector: 'app-widget-jobs',
  templateUrl: './jobs.component.html',
  styleUrls: ['./jobs.component.scss']
})
export class JobsWidgetComponent implements OnChanges, OnInit {
  
  // Inputs
  @Input()
  jobs: JourneyItemDto[]

  @Input()
  showFullDate: boolean = false;
  
  @Input()
  dashboardMode: DashboardMode = DashboardMode.Normal;

  @Output()
  onExport: EventEmitter<any> = new EventEmitter();

  private isOnExportUsed = false;

  DashboardMode = DashboardMode;

  // Private variables

  // Public variables
  jobsPage: JobItemModel[] = [];

  constructor(private router: Router) { }

  ngOnChanges(changes) {
    if (changes.jobs.firstChange === false) {
      this.updateView();
    }
  }

  ngOnInit(): void {
    this.isOnExportUsed = this.onExport.observers.length > 0;
  }

  updateView() {
    let page:  JobItemModel[] = [];
    this.jobs.forEach(service => {
        page.push(this.MapDtoToModel(service));
    });

    this.jobsPage = page;
  }

  goToRouteMap(movementId: number) {
    this.router.navigate([`/route-map/${movementId}`]);
  }

  exportData(): void {
    this.onExport.emit();
  }

  MapDtoToModel(dto: JourneyItemDto): JobItemModel {
    let model: JobItemModel = dto;
    if (this.showFullDate) {
      model.arrivedAtFormatted = DateTimeHelper.formatDateAndTime(model.arrivedAt);
      model.departedAtFormatted = DateTimeHelper.formatDateAndTime(model.departedAt);
    } else {
      model.arrivedAtFormatted = DateTimeHelper.formatDateToTime(model.arrivedAt);
      model.departedAtFormatted = DateTimeHelper.formatDateToTime(model.departedAt);
    }
    model.journeyTimeMinutesFormatted = DateTimeHelper.formatTimespan(model.journeyTimeMinutes);
    if (model.mileage) {
      model.mileageFormatted =  Math.round(model.mileage * 10) / 10;
    }
    model.mileageVarianceFormatted = Math.round(model.mileageVariance * 10) / 10;
    return model;
  }
}
